<template>
  <div class="questionnaire-page pt-3">
    <Flash v-if="error" :message="error" type="danger" v-on:close="error = ''"/>
    <Flash v-if="success" :message="success" type="success" v-on:close="success = ''"/>

    <Loader v-if="loading" />

    <div
      v-if="questionnaireId !== null"
      class="py-3 mb-2">
      <a href="#"
        @click="questionnaireId = null">
        &laquo; Вернуться к списку анкет
      </a>
    </div>

    <QuestionnaireItem
      v-if="item"
      :questionnaire="item"
      :comment-answer="commentAnswer"
      :update-answers="updateAnswers"
      :userCanEdit="userCanEdit"
      :userCanComment="userCanComment" />
    <QuestionnaireList
      v-else
      :questionnaires="questionnaires"
      v-on:select-questionnaire="selectQuestionnaire"/>
  </div>
</template>

<script>
import Loader from '../common/Loader';
import Flash from '../common/Flash';
import QuestionnaireItem from './questionnaire/Item';
import QuestionnaireList from './questionnaire/List';
export default {
  name: 'Questionnaire',

  components: {Loader, Flash, QuestionnaireList, QuestionnaireItem},

  props: ['client'],

  data() {
    return {
      loading: false,
      error: '',
      success: '',
      questionnaireId: null,
    };
  },

  created() {
    this.loadData();
  },

  computed: {
    userCanEdit() {
      return this.$security.voters.questionnaire.canEdit(this.$store.state.user);
    },

    userCanComment() {
      return this.$security.voters.questionnaire.canComment(this.$store.state.user);
    },

    item() {
      return this.questionnaires.find(
        questionnaire => this.questionnaireId === questionnaire.id
      );
    },

    answers() {
      return this.$store.getters.questionnaireClientAnswers(this.client.id);
    },

    questionnaires() {
      const answers = {};
      const questionnaires = [];

      this.answers.forEach(answer => {
        answers[answer.field] = answer;
      });

      for (const qs of this.$store.state.questionnaire.questionnaires) {
        const questionnaire = {
          id: qs.id,
          title: qs.title,
          categories: [],
          totalCount: 0,
          answeredCount: 0,
        };

        for (const c of qs.categories) {
          const category = {
            id: c.id,
            title: c.title,
            description: c.description,
            sort: c.sort,
            questions: []
          };

          for (const q of c.questions) {
            const { id, text, type, multiple, sort } = q;
            const question = {
              id,
              text,
              type,
              multiple,
              sort,
              fields: [],
              answered: false
            };

            for (const f of q.fields) {
              const field = {
                id: f.id,
                label: f.label,
                type: f.type,
                note: f.note,
                sort: f.sort,
                level: f.level,
                answer: answers[f.id],
              };

              if (typeof field.answer !== 'undefined') {
                question.answered = true;
              }

              question.fields.push(field);
            }

            questionnaire.totalCount++;
            questionnaire.answeredCount += question.answered ? 1 : 0;
            question.fields.sort((a, b) => a.sort - b.sort);
            category.questions.push(question);
          }

          category.questions.sort((a, b) => a.sort - b.sort);
          questionnaire.categories.push(category);
        }

        questionnaire.categories.sort((a, b) => a.sort - b.sort);
        questionnaires.push(questionnaire);
      }

      return questionnaires;
    },
  },

  methods: {
    async loadData() {
      try {
        this.loading = true;

        await this.$store.dispatch('QUESTIONNAIRE_LOAD_QUESTIONNAIRES');
        await this.$store.dispatch('QUESTIONNAIRE_LOAD_ANSWERS', this.client.id);
      } catch (e) {
        this.error = e.message;
      }

      this.loading = false;
    },

    selectQuestionnaire(id) {
      this.questionnaireId = id;
    },

    async commentAnswer(id, comment) {
      try {
        this.loading = true;

        const data = { id, comment, client: this.client.id };

        await this.$store.dispatch('QUESTIONNAIRE_ADD_COMMENT', data);
      } catch (e) {
        this.error = e.message;
      }

      this.loading = false;
    },

    async updateAnswers(questionnaire, answers) {
      try {
        this.loading = true;

        const data = { questionnaire, answers, client: this.client.id };

        await this.$store.dispatch('QUESTIONNAIRE_UPDATE_ANSWERS', data);
      } catch (e) {
        this.error = e.message;
      }

      this.loading = false;
    },
  }
};
</script>
